import React from 'react';
import { Helmet } from 'react-helmet';

import { css } from '@emotion/react';

import { Footer } from '../components/Footer';
import SiteNav from '../components/header/SiteNav';
import { PostFullContent } from '../components/PostContent';
import { Wrapper } from '../components/Wrapper';
import IndexLayout from '../layouts';
import {
  inner,
  outer,
  SiteArchiveHeader,
  SiteHeader,
  SiteMain,
  SiteNavMain,
} from '../styles/shared';
import { NoImage, PostFull, PostFullHeader, PostFullTitle } from '../templates/post';
import { colors } from '../styles/colors';

const PageTemplate = css`
  .site-main {
    margin-top: 64px;
    padding-bottom: 4vw;
    background: #fff;
  }

  @media (prefers-color-scheme: dark) {
    .site-main {
      /* background: var(--darkmode); */
      background: ${colors.darkmode};
    }
  }
`;

const About: React.FC = () => (
  <IndexLayout>
    <Helmet>
      <title>About - Contact</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header className="site-archive-header no-image" css={[SiteHeader, SiteArchiveHeader]}>
        <div css={[outer, SiteNavMain]}>
          <div css={inner}>
            <SiteNav isHome={false} />
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <div css={inner}>
          <article className="post page" css={[PostFull, NoImage]}>
            <PostFullHeader className="post-full-header">
              <PostFullTitle className="post-full-title">NPR website</PostFullTitle>
            </PostFullHeader>

            <PostFullContent className="post-full-content">
              <div className="post-content">
                <h5>
                  About - Contact
                </h5>
                <p>
                  Bonjour et voici le site de la Normale Physics Review !

                  Votre contribution est précieuse ! Si vous voulez participer à l’écriture d’un article, avez une idée de question, ou bien souhaitez pour nous présenter vos avis, n’hésitez pas à nous contacter :
                </p>
                <ul>
                  <li>Maïlys Rouvin, Université de Montpellier - <a href = "mailto:mailys.rouvin@gmail.com">mailys.rouvin@gmail.com</a></li>
                  <li>Jonathan Billet ϕ22 - <a href = "mailto:jonathan.billet@ens.psl.eu">jonathan.billet@ens.psl.eu</a></li>
                  <li>Lukas Péron ϕ22 - <a href = "mailto:lukas.peron@ens.psl.eu">lukas.peron@ens.psl.eu</a></li>
                  <li>Aymane Legssyer ϕ22 - <a href = "mailto:aymane.legssyer@ens.psl.eu">aymane.legssyer@ens.psl.eu</a></li>
                  <li>Juliette Savoye ϕ21 - <a href="mailto:juliette.savoye@ens.psl.eu">juliette.savoye@ens.psl.eu</a></li>
                  <li>Oriane Devigne ϕ21 - <a href="mailto:oriane.devigne@ens.psl.eu">oriane.devigne@ens.psl.eu</a></li>
                  <li>Guillaume de Rochefort ϕ19 - <a href="mailto:guillaume.de.rochefort@ens.fr">guillaume.de.rochefort@ens.fr</a></li>
                </ul>
                <p>Membres passés :</p>
                <ul>
                  <li>Victor Lequin ϕ21 - <a href="mailto:victor.lequin@ens.psl.eu">victor.lequin@ens.psl.eu</a></li>
                  <li>Rodrigue Orageux ϕ20</li>
                  <li>Esteban Foucher ϕ20</li>
                  <li>Basile Dhote ϕ19</li>
                  <li>Ludovic Brivady ϕ19</li>
                </ul>
              </div>
            </PostFullContent>
          </article>
        </div>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default About;
